<template>
	<div class="basket-form-comments text-center">
		<h4>Добавьте пожелания</h4>
    <div v-if="commentText" class="basket-form-comments__text size1 mt-4 mx-auto" v-html="commentText"></div>
		<v-row class="mt-2">
			<v-col cols="12">
				<v-textarea v-model="form.COMMENTS"
							rows="1" auto-grow
							placeholder="Пожалуйста, напишите нам любые дополнительные комментарии к вашему заказу"
				/>
			</v-col>
		</v-row>
	</div>
</template>

<script>
	export default {
		name: "basket-form-comments",
		props: {
			form: {},
		},
		data() {
			return {}
		},
    computed: {
      commentText() {
        return this.$store.state.page.BasketController?.settings?.BASKET_COMMENT_TEXT?.DETAIL_TEXT.trim();
      }
    }
	}
</script>

<style lang="scss">
.basket-form-comments {
  &__text {
    @include up($md) {
      width: 85%;
    }
  }
}
</style>